var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-header header-filter"},[_c('div'),_c('div',{staticClass:"container spacecraft-container-glass"},[_c('div',{staticClass:"mission-screen"},[_c('div',{staticClass:"row"},[_c('router-view')],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }